const editDistanceWithin = (a: string, b: string, max: number): boolean => {
  if (Math.abs(a.length - b.length) > max) return false;
  let prev = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    const curr = [i];
    for (let j = 1; j <= b.length; j++) {
      curr.push(
        Math.min(
          prev[j] + 1,
          curr[j - 1] + 1,
          prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1),
        ),
      );
    }
    prev = curr;
  }
  return prev[b.length] <= max;
};

const MAX_KEYWORD_PHRASE_WORDS = 3;

export const keywords = {
  normalize: (word: string): string =>
    word.toLowerCase().replace(/[^a-z0-9]/g, ""),

  // Fuzzy tolerance: exact under 4 chars, 1 edit under 8, else 2 edits.
  isFuzzyMatch: (a: string, b: string): boolean =>
    editDistanceWithin(a, b, a.length < 4 ? 0 : a.length < 8 ? 1 : 2),

  matchesText: ({
    keyword,
    text,
  }: {
    keyword: string;
    text: string;
  }): boolean => {
    const keywordWords = keyword
      .split(/\s+/)
      .map((word) => keywords.normalize(word))
      .filter(Boolean);
    const textWords = text
      .split(/\s+/)
      .map((word) => keywords.normalize(word))
      .filter(Boolean);

    if (!keywordWords.length || !textWords.length) return false;

    for (
      let phraseSize = MAX_KEYWORD_PHRASE_WORDS;
      phraseSize >= 1;
      phraseSize -= 1
    ) {
      for (let index = 0; index + phraseSize <= textWords.length; index += 1) {
        const phrase = textWords.slice(index, index + phraseSize).join(" ");
        if (keywords.isFuzzyMatch(phrase, keywordWords.join(" "))) return true;
      }
    }

    return false;
  },
};
